module.exports = __webpack_public_path__ + "img/Chevron-right.393dd58d.svg";